import { Stack } from 'expo-router';

import { useGetCartGestureEnabledExperiment } from 'experiments/use-disable-cart-back-gesture';
import { CartProvider } from 'state/cart';

export const unstable_settings = {
  initialRouteName: 'cart/index',
};

export default function CartLayout() {
  const gestureEnabled = useGetCartGestureEnabledExperiment();

  return (
    <CartProvider>
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: 'transparent' },
          gestureEnabled,
        }}
      >
        <Stack.Screen name="cart/index" />
        <Stack.Screen name="cart/payment/index" />
        <Stack.Screen name="cart/payment/store-confirmation" />
        <Stack.Screen
          name="cart/extras"
          options={{ presentation: 'modal', animation: 'slide_from_bottom', gestureEnabled: true }}
        />
      </Stack>
    </CartProvider>
  );
}
